import React, { useEffect, useContext, useState } from 'react';
import { _clientSettings } from '../../../../config/client-settings';
import {
    Paper,
    Avatar,
    Table,
    TableHead,
    TableBody,  
    TableRow,
    TableCell,      
    Typography,
    Hidden,
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid
} from '@material-ui/core';

import { ReportsProvider, ReportsContext } from './ReportsContext';
import { NavContext, NavRoutes, UserContext, ToastContext } from '../../../contexts';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    newReportButton: {
        fontSize: '12px'
    },
    reportTitle: {
        fontSize: '22px',
        height: '20%',
        display: 'flex',justifyContent: 'center'
    },
    dialogContainer: {
        margin: '0px 30px'
    },
    dialogBody: {
        height: '80%'
    },
    newReportName: {
        display: "flex"
    },
    reportLink: {
        display: "flex"
    },
    reportDescription: {
        display: "flex"
    },
    dialogButtons: {
        display: 'flex',
        justifyContent: 'center',
        height: '20%'
    },
    saveButton: {
        fontSize: '12px',
        marginRight: '20px',
        alignSelf: 'flex-end'
    },
    cancelButton: {
        fontSize: '12px',
        alignSelf: 'flex-end'
    },
    reportsListContainer: {
        marginTop: '40px'
    },
    allReports: {
        width: '100%',
        overflow: 'hidden',
        marginTop: '40px'
    },
    root: {
        width: '100%',
        overflow: 'hidden',
    },
    reportsListTitle: {
        fontSize: '20px',
        marginBottom: '30px'
    },
    reportName: {
        marginLeft: '10px'
    },
    viewButton: {
        display: 'flex',
        justifyContent: 'center'
    },
    deleteButton: {
        marginLeft: '20px'
    },
    icon: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        marginRight: theme.spacing(1)
    },
    table: {

    }
}));

const PageContent = (props) => {    
    const { setBreadcrumbRoot, addBreadcrumbToken } = useContext(NavContext);
    const classes = useStyles();

    const {
        showSuccessMessage,
        showWarningMessage,
        showErrorMessage
      } = useContext(ToastContext);

    const {
        navigateTo
    } = useContext(NavContext)

    const {
        state,
        addNewReportAsync,
        deleteReportAsync
	} = useContext(ReportsContext);

	const {
        addedReport
    } = state;
    
    const {
        getAllReportsAsync,
        allReports,
        resetUpdate
	} = useContext(UserContext);

    useEffect(() => {
        addBreadcrumbToken("Reports");
        getAllReportsAsync();
    }, [])
    
    const [isDialog, setIsDialog] = useState(false);
    const [reportName, setReportName] = useState(null);
    const [reportLink, setReportLink] = useState(null);
    const [reportDescription, setReportDescription] = useState(false);

    useEffect(() => {
        if (addedReport !== null){
            getAllReportsAsync();
        }
    }, [addedReport])

    function closeDialog(){
        setReportName(null);
        setReportLink(null);
        setReportDescription(null);
        setIsDialog(false);
    }

    return (
        <div>
            <Button
                variant="contained"
                color="primary"
                className={classes.newReportButton}
                onClick={() => setIsDialog(true)}
            >Add new report</Button>
            <Dialog
                open={isDialog}
                onClose={() => setIsDialog(false)}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title" className={classes.reportTitle}>Report</DialogTitle>
                <DialogContent className={classes.dialogContainer}>
                    <Grid container spacing={3} className={classes.dialogBody}>
                        <Grid item xs={12}>
                            <TextField
                                label="Title"
                                variant="outlined"
                                className={classes.newReportName}
                                //value={milestoneTitle ? milestoneTitle : ""}
                                onChange={event => {
                                    event.persist();
                                    setReportName(event.target.value);
                                }}
                            />
                            {/* <FieldError name="name" errors={errors} /> */}
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="PowerBI link"
                                variant="outlined"
                                className={classes.reportLink}
                                //value={milestoneTitle ? milestoneTitle : ""}
                                onChange={event => {
                                    event.persist();
                                    setReportLink(event.target.value);
                                }}
                            />
                            {/* <FieldError name="name" errors={errors} /> */}
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.reportDescription}
                                label="Description"
                                variant="outlined"
                                multiline
                                rowsMax="4"
                                //value={milestoneNotes ? milestoneNotes : ""}
                                onChange={(event: any) => {
                                    event.persist();
                                    setReportDescription(event.target.value);
                                }}
                            />
                            {/* <FieldError name="description" errors={errors} /> */}
                        </Grid>
                    </Grid>
                    <DialogActions className={classes.dialogButtons}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.saveButton}
                            onClick={() => {
                                if (reportName && reportLink && reportDescription){
                                    const newReport = {
                                        reportLinkId: null,
                                        name: reportName,
                                        reportUrl: reportLink,
                                        description: reportDescription
                                    };

                                    addNewReportAsync(newReport);
                                    closeDialog();
                                }

                                else 
                                    showErrorMessage("Enter each field to continue");
                            }}
                        >
                            Save
                        </Button>
                        <Button
                            variant="contained"
                            className={classes.cancelButton}
                            onClick={() => closeDialog()}
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>

            <Paper className={classes.allReports}>
                <Table className={classes.table} arial-label="role table">
                    <TableBody>
                        <TableRow hover>
                            <TableCell component="th" scope="row">
                                <div className={classes.icon}>
                                    <Avatar aria-label="recipe" className={classes.avatar}>
                                        <svg style={{width: '1em', height: '1em', minWidth: '56px', color: '#fff', marginLeft: (window.document as any).documentMode ? '-7px' : '0px'}} className="MuiSvgIcon-root MuiSvgIcon-colorPrimary" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                                            <path d="M20.38 8.57l-1.23 1.85a8 8 0 01-.22 7.58H5.07A8 8 0 0115.58 6.85l1.85-1.23A10 10 0 003.35 19a2 2 0 001.72 1h13.85a2 2 0 001.74-1 10 10 0 00-.27-10.44z" />
                                            <path d="M10.59 15.41a2 2 0 002.83 0l5.66-8.49-8.49 5.66a2 2 0 000 2.83z" />
                                        </svg>
                                    </Avatar>                                
                                    <Typography className={classes.reportName}>
                                        All Power BI reports
                                    </Typography>
                                </div>
                            </TableCell>
                            <TableCell align="left">
                                <Typography>
                                    <span>
                                        {_clientSettings.StaticReport.substring(0, 60)}
                                        {
                                            _clientSettings.StaticReport.length > 60 &&
                                            "..."
                                        }
                                    </span>
                                </Typography>
                            </TableCell>
                            <TableCell align="right">
                                <div className={classes.viewButton}>
                                    <Button 
                                        color="primary"
                                        size="small"
                                        variant="contained"
                                        onClick={() => window.open(_clientSettings.StaticReport, "_blank")}
                                    >
                                        View
                                    </Button>
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

            <div className={classes.reportsListContainer}>
                <Paper className={classes.root}>
                    <Table className={classes.table} arial-label="role table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.reportsListTitle}>
                                    Reports list
                                </TableCell>
                                <TableCell align="center"></TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {allReports &&
                            allReports.items &&
                            allReports.items.length > 0 &&
                            allReports.items.map((report, index) => 
                                <TableRow hover key={index}>
                                    <TableCell component="th" scope="row">
                                        <div className={classes.icon}>
                                            <Avatar aria-label="recipe" className={classes.avatar}>
                                                <svg style={{width: '1em', height: '1em', minWidth: '56px', color: '#fff', marginLeft: (window.document as any).documentMode ? '-7px' : '0px'}} className="MuiSvgIcon-root MuiSvgIcon-colorPrimary" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                                                    <path d="M20.38 8.57l-1.23 1.85a8 8 0 01-.22 7.58H5.07A8 8 0 0115.58 6.85l1.85-1.23A10 10 0 003.35 19a2 2 0 001.72 1h13.85a2 2 0 001.74-1 10 10 0 00-.27-10.44z" />
                                                    <path d="M10.59 15.41a2 2 0 002.83 0l5.66-8.49-8.49 5.66a2 2 0 000 2.83z" />
                                                </svg>
                                            </Avatar>                                
                                            <Typography className={classes.reportName}>
                                                {report.name}
                                            </Typography>
                                        </div>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography>
                                            <span>
                                                {report.reportUrl.substring(0, 60)}
                                                {report.reportUrl.length > 60 &&
                                                "..."}
                                            </span>
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                        <div className={classes.viewButton}>
                                            <Button 
                                                color="primary"
                                                size="small"
                                                variant="contained"
                                                onClick={() => {
                                                    resetUpdate();
                                                    navigateTo(NavRoutes.Admin.EditReport, [report.reportLinkId]);
                                                }}
                                            >
                                                View
                                            </Button>
                                            <Button
                                                className={classes.deleteButton}
                                                color="secondary"
                                                size="small"
                                                variant="contained"
                                                onClick={() => {
                                                    if (window.confirm("Are you sure you want to delete this report?"))
                                                        sendDataAsync();
    
                                                    async function sendDataAsync(){
                                                        await deleteReportAsync(Number(report.reportLinkId));
                                                        getAllReportsAsync();
                                                    }
                                                }}
                                            >
                                                Delete
                                            </Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Paper>
            </div>
        </div>
    );
}

export const ReportsPage = () =>
    <ReportsProvider>
        <PageContent />
    </ReportsProvider>;